import React from 'react';
import './PostCardSkeleton.css';

const PostCardSkeleton: React.FC = () => (
  <article className="post-card-skeleton" aria-hidden="true">
    <div className="post-card-skeleton__header">
      <div className="post-card-skeleton__avatar skeleton-shimmer" />
      <div className="post-card-skeleton__meta">
        <div className="post-card-skeleton__line skeleton-shimmer skeleton-shimmer--short" />
        <div className="post-card-skeleton__line skeleton-shimmer skeleton-shimmer--tiny" />
      </div>
    </div>
    <div className="post-card-skeleton__body">
      <div className="post-card-skeleton__line skeleton-shimmer" />
      <div className="post-card-skeleton__line skeleton-shimmer skeleton-shimmer--medium" />
    </div>
    <div className="post-card-skeleton__media skeleton-shimmer" />
    <div className="post-card-skeleton__footer">
      <div className="post-card-skeleton__pill skeleton-shimmer" />
      <div className="post-card-skeleton__pill skeleton-shimmer" />
      <div className="post-card-skeleton__pill skeleton-shimmer" />
    </div>
  </article>
);

export const FeedSkeleton: React.FC<{ count?: number }> = ({ count = 3 }) => (
  <div className="feed-skeleton" aria-busy="true" aria-label="Loading posts">
    {Array.from({ length: count }, (_, i) => (
      <PostCardSkeleton key={i} />
    ))}
  </div>
);

export default PostCardSkeleton;
